import { BookingModel } from "src/app/_models/booking.model";
import { QrCode } from "src/app/_models/qrcode.model";
import { User, UserBasic } from "src/app/_models/user.model";
import { Config } from "src/app/_services/config.service";
import { Guest } from "./guest/guest.model";

export class Invitation {
  public id: number;
  public idUserHost: number;
  public idBuilding: number;
  public title: string;
  public description: string;
  //#region Date and Time Pickers variables
  public dateStart: Date;
  public dateEnd: Date;
  public timeStart: string;
  public timeEnd: string;
  public data: Date;
  //#endregion
  public type = 0;
  public invitationGuests: Guest[] = [];
  public invitationEmployees: User[] = [];
  public user: UserBasic = new UserBasic();
  public addressGoogle?: string;
  public adress?: string;
  public formatedData?: string;
  public template: Config;
  public invitationBookings?: BookingModel[];
  public bookings?: any;
}

export class InvitationUrlActionDto {
  key: string;
  type: number;
}

export class InvitationEntry {
  id: number;
  date: Date;
  type: InvitationEntryType;
  idDevice: number;
  idQrcode: number;
  qrcode: QrCode;
}
export class Device {
  id: number;
  type: number;
  idApp: number;
  idBuilding: number;
  active: boolean;
  token: string;
  hostIp: string;
  port: number;
  description: string;
}

export enum InvitationEntryType {
  Entry = 1,
  Exit = 2,
}

export class InvitationFilter {
  companyId: number;
  showAllInvitations: boolean = false;
  date: number = new Date().setHours(0, 0, 0, 0);
  deviceId: number;
  dateStart: Date;
  dateEnd: Date;
}
